module.exports = __webpack_public_path__ + "static/media/logo.8c773a8a.png";